import { Link } from "react-router-dom";
import { SocialShare } from "../components/subcomponents/Sharesocial";
import { routes } from "../utils/utils.routes";
import { ContactLink } from "../components/subcomponents/ContactComponent";
import { Hrseparator } from "../components/subcomponents/Hrseparator";
import { BreadcrumpComponent } from "../components/subcomponents/BreadcrumpCompont";
import { PageSectionHeader } from "../components/subcomponents/PageSectionHeader";
import hero from "../assets/images/hero-image.png";

export const Kauta = () => {
    return (
        <>
            <BreadcrumpComponent
                imageCover={hero}
                title="École primaire Kauta"
                subtitle="École primaire affiliée à l'Université Libre des Pays des Grands Lacs, dédiée à l'éducation fondamentale des enfants de la région de Goma."
            />

            <div className="container page-content">
                <div className="row">
                    <aside className="col-md-4 pe-md-5">
                        <SocialShare slug="ecole-kauta" title="École primaire Kauta" description="École primaire affiliée à l'Université Libre des Pays des Grands Lacs, dédiée à l'éducation fondamentale des enfants de la région de Goma." />

                        <div className="mt-5 pt-5">
                            <PageSectionHeader
                                eyebrow="Explorer"
                                title="Voir aussi"
                                size="compact"
                                align="start"
                            />
                            <ul className="list-unstyled detail-section__list">
                                <li className="mb-2">
                                    <Link to={routes.METANOIA} className="text-decoration-none text-dark">
                                        Institut Metanoia
                                    </Link>
                                </li>
                                <li className="mb-2">
                                    <Link to={routes.KAUTA_MATERNEL} className="text-decoration-none text-dark">
                                        La Crèche
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </aside>

                    <main className="col-md-8">
                        <article className="entry-content detail-sections">
                            <section className="detail-section detail-section--first">
                                <PageSectionHeader
                                    eyebrow="Présentation"
                                    title="Profil et localisation de l'école"
                                    size="compact"
                                    align="start"
                                />
                                <div className="row g-3">
                                    <div className="col-12 col-lg-6">
                                        <iframe
                                            width="100%"
                                            height="400"
                                            src="https://www.youtube.com/embed/-Fro1Ru_tk0"
                                            title="EMP KAUTA"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            referrerPolicy="strict-origin-when-cross-origin"
                                            allowFullScreen
                                        />
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <iframe
                                            width="100%"
                                            height="400"
                                            src="https://www.youtube.com/embed/nkUEXLFGQ8Q"
                                            title="EMP KAUTA"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            referrerPolicy="strict-origin-when-cross-origin"
                                            allowFullScreen
                                        />
                                    </div>
                                </div>
                            </section>

                            <section className="detail-section">
                                <PageSectionHeader
                                    eyebrow="Équipe"
                                    title="Direction"
                                    size="compact"
                                    align="start"
                                />
                                <p className="detail-section__highlight">MIHANDA Esther</p>
                            </section>

                            <section className="detail-section">
                                <PageSectionHeader
                                    eyebrow="Contact"
                                    title="Contacts"
                                    size="compact"
                                    align="start"
                                />
                                <ul className="detail-section__list">
                                    <li><ContactLink value="0853125385" /></li>
                                </ul>
                            </section>
                        </article>
                    </main>
                </div>
                <Hrseparator />
            </div>
        </>
    );
};
